import { render, staticRenderFns } from "./CreateBase.vue?vue&type=template&id=43926152&scoped=true"
import script from "./CreateBase.vue?vue&type=script&lang=js"
export * from "./CreateBase.vue?vue&type=script&lang=js"
import style0 from "./CreateBase.vue?vue&type=style&index=0&id=43926152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43926152",
  null
  
)

export default component.exports